import { c as _c } from "react/compiler-runtime";
import type { CicStatement } from "@/entities/IProfile";
import UserPageIdentityStatementsStatementsList from "../utils/UserPageIdentityStatementsStatementsList";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageIdentityStatementsSocialMediaVerificationPosts(t0) {
  const $ = _c(6);
  const {
    statements,
    profile,
    loading
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-items-center tw-space-x-4"><div className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-950 tw-border tw-border-solid tw-border-iron-800"><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-100" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M13 17H7M15 13H7M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div><span className="tw-text-base tw-font-semibold tw-text-iron-100">Social Media Verification Posts</span></div>;
    t2 = <div className="tw-mt-3 tw-h-px tw-bg-white/5 tw-w-full" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== loading || $[3] !== profile || $[4] !== statements) {
    t3 = <div>{t1}{t2}<UserPageIdentityStatementsStatementsList statements={statements} profile={profile} noItemsMessage="No Social Media Verification Post added yet" loading={loading} /></div>;
    $[2] = loading;
    $[3] = profile;
    $[4] = statements;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}